<main class="h-screen overflow-y-auto">
  <router-outlet></router-outlet>
</main>
<finance-pwa-bottom-nav *ngIf="loggedIn"></finance-pwa-bottom-nav>
<finance-pwa-install-button *ngIf="loggedIn"></finance-pwa-install-button>
